import { css } from '@emotion/css';

import { commonMathStyles, editableMathStyles, readOnlyMathStyles } from './mathStyles';
import { plyrStyles } from './plyrStyles';
import { selectedStateStyles } from './selectedState';
import { tableStyles } from './tables';
import { yjsCursorsStyles } from './yjsCursorsStyles';

const baseEditorStyles = css`
  ${tableStyles}
  ${plyrStyles}

  .ProseMirror .placeholder::before {
    color: #aaa;
    display: block;
    pointer-events: none;
    content: attr(data-placeholder);
    height: 0;
  }

  & div.ProseMirror-focused {
    outline: none;
  }

  .ProseMirror .ProseMirror-selectednode {
    // It will be decided later what to do when the user is in editable mode.
    outline: none;
  }

  .ProseMirror *::selection {
    color: black;
    background: #e4e7eb;
  }

  .ProseMirror div.code-block *::selection {
    background: #e4e7eb;
    color: inherit;
  }

  .ProseMirror .ProseMirror__reactComponent *::selection {
    color: black;
    background: #e4e7eb;
  }

  .ProseMirror .ProseMirror__reactComponent textarea::selection {
    color: black;
    background: #e4e7eb;
  }

  .ProseMirror .ProseMirror__reactComponent .flip-card textarea::selection {
    color: inherit;
    background: #e4e7eb;
  }

  .ProseMirror-hideselection textarea::selection {
    color: inherit;
    background: transparent !important;
  }

  .ProseMirror img::selection {
    color: black;
    background: none;
  }

  .ProseMirror img,
  .ProseMirror video {
    width: 100%;
  }

  pre {
    display: block;
    overflow-x: auto;
    position: relative;
    -webkit-font-smoothing: initial;
    font-family: Roboto Mono;
    font-size: 14px;
    line-height: 1.5em;
    background: var(--gray-100);
    direction: ltr;
    text-align: left;
    white-space: pre-wrap;
    word-spacing: normal;
    word-break: normal;
    tab-size: 4;
    -webkit-hyphens: none;
    -moz-hyphens: none;
    -ms-hyphens: none;
    hyphens: none;
  }
`;

export const editableEditorStyles = (content: string) => css`
  ${baseEditorStyles}

  ${editableMathStyles}
  ${commonMathStyles(content)}
  ${selectedStateStyles}
  ${yjsCursorsStyles}
`;

export const readOnlyEditorStyles = (content: string) => css`
  ${baseEditorStyles}
  ${readOnlyMathStyles}
  ${commonMathStyles(content)}
`;
